import * as React from 'react';
import { View } from 'react-native';
import { TextNormal } from '../common/Typography';
import { ViewStyle } from 'react-native';
import { useHover } from 'react-native-web-hooks';
import colors from '../../constants/colors';
import { TrainerDocument } from '../../types';

const TrainerItemCell = ({
  trainer, // trainer
  style,
  onClick,
}: {
  trainer: TrainerDocument;
  style?: ViewStyle;
  onClick: (event: any, trainer: any) => void;
}) => {
  const ref = React.useRef(null);

  const isHovered = useHover(ref);

  const color = 'black';

  return (
    // @ts-ignore
    <View
      onClick={(event: any) => onClick(event, trainer)}
      ref={ref}
      style={[
        {
          height: 60,
          paddingHorizontal: 10,
          borderWidth: 1,
          borderColor: colors.borderColor,
          borderRadius: 10,
          // @ts-ignore
          cursor: 'pointer',
          flexDirection: 'row',
          backgroundColor: colors.white,
        },
        isHovered && {
          'box-shadow': '-2px 6px 7px -5px rgba(92,92,92,1)',
        },
        style,
      ]}
    >
      <Section label={trainer.user.email} />
      <Section label={`${trainer.user.firstName} ${trainer.user.lastName}`} />
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          paddingLeft: 5,
        }}
      >
        <TextNormal style={{ color: color }}>
          {100 - trainer.customShareRate}
        </TextNormal>
      </View>
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          paddingLeft: 5,
        }}
      >
        <TextNormal style={{ color: color }}>
          {trainer.customShareRate}
        </TextNormal>
      </View>
    </View>
  );
};

export default TrainerItemCell;

export const Section = ({
  label,
  onClick,
  withHover,
  sorted,
}: {
  label: string;
  onClick?: () => void;
  withHover?: boolean;
  sorted?: boolean;
}) => {
  const ref = React.useRef(null);

  const isHovered = useHover(ref);

  return (
    <View
      ref={ref}
      // @ts-ignore
      style={[
        { flex: 1, justifyContent: 'center', paddingLeft: 5 },
        isHovered && withHover
          ? {
              // @ts-ignore
              'box-shadow': '-2px 6px 7px -5px rgba(92,92,92,1)',
            }
          : null,
      ]}
      // @ts-ignore
      onClick={onClick}
    >
      <TextNormal style={{ fontWeight: sorted ? 'bold' : 'normal' }}>
        {label}
      </TextNormal>
    </View>
  );
};
